module.exports = "<span>&copy;  Todos os direitos reservados ao FIDEL SOLUÇÕES EM MARKETING LTDA. - <b>Versão 1.0.0</b></span>\r\n"